
$( function() {
    document.querySelectorAll( '.testimonials__slider' ).forEach( testimonialSlider => {
        $( testimonialSlider ).slick( {
            slidesToScroll: 1,
            autoplay: 10000,
            speed: 800,
            cssEase: 'ease-in-out',
            arrows: false,
        })
    })
})